import Reveal from "./Reveal";
import { SERVICES } from "@/data/content";

const Services = () => (
  <section id="services" data-testid="services-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-3xl mx-auto">
        <span className="text-sm font-bold uppercase tracking-wider text-primary">What We Offer</span>
        <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-foreground leading-tight">
          Courier Services Built for <span className="text-primary">Speed &amp; Reliability</span>
        </h2>
        <p className="mt-4 text-muted-foreground text-base md:text-lg">
          From urgent same-day specimen transport to scheduled hospital logistics, we cover every
          critical medical delivery need.
        </p>
      </Reveal>

      <div className="mt-12 md:mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={i * 0.06}>
              <div className="group h-full rounded-2xl border border-border bg-white p-6 md:p-7 shadow-sm hover:shadow-xl hover:shadow-primary/10 hover:border-primary/30 transition-all duration-300">
                <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 group-hover:bg-primary transition-colors duration-300">
                  <Icon className="w-7 h-7 text-primary group-hover:text-white transition-colors duration-300" />
                </span>
                <h3 className="mt-5 text-lg font-bold text-foreground">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
